import { LayoutGrid } from "lucide-react";
import { budgetConfig } from "@/modern/components/entity-finder/constants/config/budget";
import { noteConfig } from "@/modern/components/entity-finder/constants/config/note";
import { clientConfig } from "@/modern/components/entity-finder/constants/config/client";
import { contactConfig } from "@/modern/components/entity-finder/constants/config/contact";
import { resourceConfig } from "@/modern/components/entity-finder/constants/config/resource";
import { settingsConfig } from "@/modern/components/entity-finder/constants/config/settings";
import { taskConfig } from "@/modern/components/entity-finder/constants/config/task";
import { userConfig } from "@/modern/components/entity-finder/constants/config/user";
import { viewsConfig } from "@/modern/components/entity-finder/constants/config/views";
import type { EntityFinderConfigEntryRuntime, EntityFinderKind } from "@/modern/components/entity-finder/types";

export const ENTITY_FINDER_CONFIG = [
  viewsConfig,
  taskConfig,
  resourceConfig,
  clientConfig,
  contactConfig,
  userConfig,
  budgetConfig,
  noteConfig,
  settingsConfig,
] as EntityFinderConfigEntryRuntime[];

export const ENTITY_FINDER_SCOPE_ORDER: EntityFinderKind[] = ENTITY_FINDER_CONFIG.filter(
  (entry) => entry.showInFilter
).map((entry) => entry.type);

export function getConfigEntry(type: EntityFinderKind): EntityFinderConfigEntryRuntime | undefined {
  return ENTITY_FINDER_CONFIG.find((entry) => entry.type === type);
}

export function getEntityFinderScopeMeta(type: EntityFinderKind) {
  const entry = getConfigEntry(type);
  if (!entry) {
    return {
      scope: type,
      label: type,
      plural: type,
      icon: LayoutGrid,
      tint: "bg-muted text-muted-foreground",
    };
  }
  return {
    scope: entry.type,
    label: entry.label,
    plural: entry.plural,
    icon: entry.icon,
    tint: entry.tint,
  };
}
